import type { CaseDetail, CaseListResponse, HealthResponse } from './types'

const BASE = '/api'

async function jget<T>(path: string): Promise<T> {
  const r = await fetch(`${BASE}${path}`)
  if (!r.ok) {
    const text = await r.text().catch(() => '')
    throw new Error(`GET ${path} → ${r.status}: ${text || r.statusText}`)
  }
  return r.json() as Promise<T>
}

export const api = {
  health: () => jget<HealthResponse>('/health'),
  listCases: () => jget<CaseListResponse>('/cases'),
  getCase: (id: string) => jget<CaseDetail>(`/cases/${encodeURIComponent(id)}`),

  async uploadDicomZip(file: File): Promise<unknown> {
    const fd = new FormData()
    fd.append('dicom_zip', file)
    const r = await fetch(`${BASE}/live/infer`, { method: 'POST', body: fd })
    if (!r.ok) {
      const text = await r.text().catch(() => '')
      throw new Error(`upload → ${r.status}: ${text || r.statusText}`)
    }
    return r.json()
  },
}
